import { GlobalEnumsAceSprache } from "./api/model-index";
import de_core from 'src/assets/i18n/core/de.json'
import de_customized from 'src/assets/i18n/customized/de.json'
import en_core from 'src/assets/i18n/core/en.json'
import en_customized from 'src/assets/i18n/customized/en.json'
import localeDeCa from '@angular/common/locales/de';
import localeEnCa from '@angular/common/locales/en';
import localeDeCaExtra from '@angular/common/locales/extra/de';
import localeEnCaExtra from '@angular/common/locales/extra/en';

export class Constants {
    public static EDITOR_CONFIG =
        {
            language: 'en',
            toolbar: [
                'heading', 
            '|', 'bold', 'italic', 'underline', 'strikethrough', 
            '|', 'fontColor', 'fontBackgroundColor', 
            '|', 'link', 'insertTable', 
            '|', 'bulletedList', 'numberedList', 'blockQuote', 'alignment', 
            '|', 'outdent', 'indent', 
            '|', 'undo', 'redo', 'removeFormat'
            ],
            heading: {
                options: [
                    { model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' },
                    { model: 'heading1', view: 'h1', title: 'Heading 1', class: 'ck-heading_heading1' },
                    { model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2' }
                ]
            },
            wordCount: {
                displayWords: true,
                displayCharacters: true,
            },
            alignment: {
                options: ['left', 'right', 'center', 'justify']
            },
            indentBlock: {
                offset: 1,
                unit: 'em'
            },
            plugins: [
                'RemoveFormat',
                'Undo',
                'IndentBlock',
                'Indent',
                'Table',
                'TableToolbar',
                'FontColor',
                'FontBackgroundColor',
                'Alignment',
                'Heading',
                'BlockQuote',
                'Bold',
                'Essentials',
                'Image',
                'ImageStyle',
                'ImageToolbar',
                'Indent',
                'Italic',
                'Link',
                'List',
                //'MediaEmbed',
                'Paragraph',
                'SpecialCharacters',
                'Strikethrough',
                'Table',
                'TableToolbar',
                'Underline',
                'WordCount']
        }

    public static PROJECT_DATA = {
        PROJEKTBESCHREIBUNG_MAXLENGTH: 4000,
        PROJEKTBETEILIGTE_MAXLENGTH: 500,
    }

    public static CURRENCY_FORMAT_OPTIONS: any = {
        style: "currency",
        currency: "EUR"
    };

    public static GUTACHTEN = {
        INHALTLICHEZUSAMMENFASSUNG_MAXLENGTH: 4000,
        STAERKENSCHWAECHENANALYSE_MAXLENGTH: 4000,
        ERGEBNIS_MAXLENGTH: 4000,
    }

    public static BRAND_LOGO_FILE_NAME = 'brand_logo.png';

    public static DIALOG = {
        MAX_WIDTH: "90%",
        MAX_HEIGHT: "90%",
        WIDTH: "35rem",
    }

    /* Language Stuff */ 
    /* comments are Examples for extention */
    public static LANG_SUPPORTED_LANGUAGES: string[] = ['de','en' /*, 'en-GB'*/ ]

    public static LANG_LANGUAGE_IMPORTPATHS: {localeId: string, coreJson: any, customizedJson: any, locale: any, localeextra: any}[] = [
        {localeId: this.LANG_SUPPORTED_LANGUAGES[0] , coreJson: de_core, customizedJson: de_customized, locale: localeDeCa, localeextra: localeDeCaExtra},
        {localeId: this.LANG_SUPPORTED_LANGUAGES[1] , coreJson: en_core, customizedJson: en_customized, locale: localeEnCa, localeextra: localeEnCaExtra},
        //{localeId: this.LANG_SUPPORTED_LANGUAGES[2] , coreJson: en_core, customizedJson: en_customized, locale: localeEnGb, localeextra: localeEnGbExtra}
    ]

    public static LANG_DATEFORMATS_FOR_CHAT_MESSAGES: {localeId: string, format: string}[] = [
        {localeId: this.LANG_SUPPORTED_LANGUAGES[0], format: "dd.MM. H:mm"},
        {localeId: this.LANG_SUPPORTED_LANGUAGES[1], format: "M/d. h:mm a"},
        //{localeId: this.LANG_SUPPORTED_LANGUAGES[2], format: "d/M. h:mm a"},
    ]

    public static LANG_LANGUAGE_DISPLAY_ENUM: {localeId: string, displayName: string, enumValue: GlobalEnumsAceSprache}[] = [
        {localeId: this.LANG_SUPPORTED_LANGUAGES[0], displayName: 'Deutsch', enumValue: GlobalEnumsAceSprache.Deutsch},
        {localeId: this.LANG_SUPPORTED_LANGUAGES[1], displayName: 'English', enumValue: GlobalEnumsAceSprache.Englisch},
        //{localeId: this.LANG_SUPPORTED_LANGUAGES[2], displayName: 'GB', enumValue: GlobalEnumsAceSprache.Englisch}
    ]

}